var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 6v8.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.22 19 16.38 19 14.7 19H7.3c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2.5 16.72 2.5 15.88 2.5 14.2V6m.1-5h16.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C21 1.76 21 2.04 21 2.6v1.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C20.24 6 19.96 6 19.4 6H2.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C1 5.24 1 4.96 1 4.4V2.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C1.76 1 2.04 1 2.6 1zm6 8.5h4.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C15 10.26 15 10.54 15 11.1v.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437c-.214.109-.494.109-1.054.109H8.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C7 12.74 7 12.46 7 11.9v-.8c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C7.76 9.5 8.04 9.5 8.6 9.5z",
    stroke: "#006997",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.0fe5106564756503685413106958ccf0.svg";
export { ForwardRef as ReactComponent };